function r(e) {
  return typeof e == "number" && !Number.isNaN(e);
}
export {
  r as isValidNumber
};
